import React, { useEffect } from "react";

/**
 * LightModeLayout Component
 *
 * Theme-forcing wrapper that continuously enforces data-theme="light" on the document root.
 * Does NOT provide any UI structure (navbar/footer) - those are handled by LegacyLayout.
 * Uses a MutationObserver to watch for theme attribute changes and force them back to light.
 * Prevents external code (screenshot tool, theme toggle, etc.) from overriding the light theme.
 *
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render
 */
export function LightModeLayout({ children }) {
  useEffect(() => {
    const root = document.documentElement;

    // Force light theme initially
    root.setAttribute("data-theme", "light");

    // Watch for attribute changes and force it back to light
    const observer = new MutationObserver(() => {
      if (root.getAttribute("data-theme") !== "light") {
        root.setAttribute("data-theme", "light");
      }
    });

    observer.observe(root, { attributes: true, attributeFilter: ["data-theme"] });

    // Cleanup: disconnect observer on unmount
    return () => observer.disconnect();
  }, []);

  return <>{children}</>;
}

export default LightModeLayout;

